import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class CNCDepartmentService extends SingleDepartmentService {
  private _departmentId: number;
  set departmentId(value: number) {
    this._departmentId = value;
  }

  get departmentId(): number {
    return this._departmentId;
  }

  readonly NAME = 'Machining';

  defaultRoutes(roles: string[]): boolean {
    const expectedRole = [
      'CNC',
      'CncViewer',
      'CncSupervisor',
      'CncOperator',
      'CncLeader',
      'CncAdmin',
      'CncChief',
    ];
    if (roles.some((item) => expectedRole.includes(item))) {
      this.router.navigate(['/sb/cnc/scheduler']);
      return true;
    }
    if (
      roles.some((item) =>
        ['Programmer', 'CncDeveloper', 'CncProgrammer'].includes(item)
      )
    ) {
      this.router.navigate(['/sb/cnc/projects']);
      return true;
    }
    if (roles.some((item) => ['CncCleaning'].includes(item))) {
      this.router.navigate(['/sb/cnc/scheduler/cleaning']);
      return true;
    }
    return false;
  }
}
